import AppRoutes from "./Routes";
import { BrowserRouter } from "react-router-dom";
import { Amplify } from "aws-amplify";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { withAuthenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";

import awsExports from "./aws-exports";
import { AuthProvider } from "./contexts/AuthContext";
import { SnackbarProvider } from "notistack";

Amplify.configure(awsExports);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App({ signOut, user }) {
  console.log("user: ", user?.attributes);

  return (
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      autoHideDuration={3000}
      variant="success"
    >
      <QueryClientProvider client={queryClient}>
        <AuthProvider user={user?.attributes} signOut={signOut}>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </AuthProvider>
      </QueryClientProvider>
    </SnackbarProvider>
  );
}

const amplifyConfig = {
  // components: {
  //   Header() {
  //     return (
  //       <div style={{ padding: "20px", textAlign: "center" }}>
  //         <h1>Welcome to BatteryPool Tools App</h1>
  //         <p>Please sign in to continue</p>
  //       </div>
  //     );
  //   },
  // },
  hideSignUp: true,
  usernameAlias: "email",
};

export default withAuthenticator(App, amplifyConfig);
